import React, { Component } from 'react'
import WorldGameContainer from '../../game/WorldGameContainer';

class Home extends Component {

    render() {

        return (
        <main>
            <WorldGameContainer />
        </main>
        )
    }
}

export default Home



// WEBPACK FOOTER //
// ./src/layouts/home/Home.js